import { useEffect } from 'react'

// A single-page app serves one index.html, so every route shares its <title>
// and description unless something changes them on navigation. Search engines
// read that as duplicate pages.
//
// Written by hand rather than with react-helmet: this is the whole of what the
// site needs, and the build already carries enough dependencies.
const setMeta = (name, content) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }

  tag.setAttribute('content', content)
}

const setCanonical = (url) => {
  let tag = document.head.querySelector('link[rel="canonical"]')

  if (!tag) {
    tag = document.createElement('link')
    tag.setAttribute('rel', 'canonical')
    document.head.appendChild(tag)
  }

  tag.setAttribute('href', url)
}

export const usePageMeta = (title, description, path) => {
  useEffect(() => {
    document.title = title
    setMeta('description', description)

    if (path) {
      setCanonical(`https://hbranch.ca${path}`)
    }
  }, [title, description, path])
}

export default usePageMeta
